import TabPanel from "devextreme-react/tab-panel";
import { Fragment } from "react";

const Tab = ({
  tabs,
  setTabs,
  homeKey,
  selectedTabIndex,
  setSelectedTabIndex,
}) => {
  const onTabSelectionChanged = (e) => {
    setSelectedTabIndex(
      tabs.findIndex((it) => it.title === e.addedItems[0].title)
    );
  };

  //on tab close button click
  const onTabClose = (title) => {
    const tabIndex = tabs.findIndex((it) => it.title === title);
    setTabs(tabs.filter((it) => it.title !== title));
    setSelectedTabIndex(tabIndex - 1);
  };

  //render custom tab title with text and close button
  const renderTitle = ({ title }) => {
    return (
      <Fragment>
        <div className="w-56 ">
          <div>{title}</div>
          {title === homeKey ? null : (
            <i
              className="dx-icon dx-icon-close fixed right-0 top-0"
              onClick={(e) => onTabClose(title)}
            />
          )}
        </div>
      </Fragment>
    );
  };
  //render custom tab item
  const renderItem = ({ title, Component, data, mode }) => {
    return (
      <div className="p-2">
        <Fragment>
          <Component data={data} mode={mode} close={() => onTabClose(title)} />
        </Fragment>
      </div>
    );
  };
  return (
    <div>
      <TabPanel
        dataSource={tabs}
        focusStateEnabled={true}
        repaintChangesOnly={true}
        selectedIndex={selectedTabIndex}
        onSelectionChanged={onTabSelectionChanged}
        itemTitleRender={renderTitle}
        itemRender={renderItem}
      ></TabPanel>
    </div>
  );
};

export default Tab;
